import Error from '../shared/error';
import { APIErrorType } from '../../api';
import Loader from '../shared/loader';
import { useExamReportsChartData } from '../../hooks/react-query/use-exam-report';
import ProgressChart from './progress-chart';

function ProgressChartContainer() {
  const {
    isError: examReportsIsError,
    error: examReportsError,
    isLoading: examReportsIsLoading,
    data: examReports
  } = useExamReportsChartData();

  if (examReportsIsError) {
    const error = examReportsError as APIErrorType;
    return <Error error={error} />;
  }

  if (examReportsIsLoading || !examReports) return <Loader />;
  if (examReports.length < 2) {
    return (
      <div className='m-6 text-center text-red-500'>
        <span>برای دیدن </span>
        <span className='font-bold'>نمودار سیر پیشرفت</span>
        <span> باید حداقل در 2 آزمون‌ اخیر از آزمون های دوره‌ای مدمشاور را شرکت کرده باشید.</span>
      </div>
    );
  }

  return (
    <div className='text-center'>
      <ProgressChart examReports={examReports} />
    </div>
  );
}

export default ProgressChartContainer;
